import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  { path: '/enemy/:id?', name: 'Enemy', component: () => import(/* webpackChunkName: "about" */ '../views/Enemy.vue') },
  { path: '/world/', name: 'World', component: () => import(/* webpackChunkName: "about" */ '../views/World.vue') },
  { path: '/world/:area/', name: 'Area', component: () => import(/* webpackChunkName: "about" */ '../views/Area.vue') },
  { path: '/world/:area/:zone?/:stage?', name: 'Zone', component: () => import(/* webpackChunkName: "about" */ '../views/Zone.vue') },
  { path: '/:pathMatch(.*)*', name: 'Error', component: () => import(/* webpackChunkName: "about" */ '../views/Error.vue') },
  { path: '/sanctum/', name: 'Sanctum', component: () => import(/* webpackChunkName: "about" */ '../views/Sanctum.vue') },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
